(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function productUrl(product) {
    if (product && product.url) return product.url;
    return product && product.handle ? '/products/' + product.handle : '#';
  }

  function sizedImageUrl(source, width) {
    if (!source) return '';

    try {
      var imageUrl = new URL(source, window.location.origin);
      imageUrl.searchParams.set('width', String(width));
      return imageUrl.toString();
    } catch (error) {
      return source;
    }
  }

  function studioProductCard(product, index) {
    var imageSmall = product && product.image ? sizedImageUrl(product.image, 360) : '';
    var imageLarge = product && product.image ? sizedImageUrl(product.image, 720) : '';
    var image = imageLarge
      ? '<img src="' + escapeHtml(imageLarge) + '"' +
        ' srcset="' + escapeHtml(imageSmall) + ' 360w, ' + escapeHtml(imageLarge) + ' 720w"' +
        ' sizes="(min-width: 990px) 24vw, 52vw"' +
        ' alt="' + escapeHtml(product.title) + '"' +
        ' loading="eager"' +
        (index === 0 ? ' fetchpriority="high"' : '') +
        '>'
      : '';
    var price = product && product.price_money
      ? '<span>' + escapeHtml(product.price_money) + '</span>'
      : '';

    return (
      '<a class="ccf-studio-product ccf-studio-product--' + (index + 1) + '"' +
      ' href="' + escapeHtml(productUrl(product)) + '"' +
      ' aria-label="' + escapeHtml(product.title) + '" data-ccf-studio-product>' +
      '<span class="ccf-studio-product__image">' + image + '</span>' +
      '<span class="ccf-studio-product__meta"><strong>' +
      escapeHtml(product.title) +
      '</strong>' + price + '</span></a>'
    );
  }

  function hydrateStudioHero() {
    document.querySelectorAll('[data-ccf-studio-hero]').forEach(function (root) {
      if (root.dataset.ccfHydrated === 'true') return;
      var target = root.querySelector('[data-ccf-studio-products]');
      var campaignLink = root.querySelector('[data-ccf-campaign-link]');
      var campaignTiles = Array.prototype.slice.call(root.querySelectorAll('[data-ccf-campaign-product]'));
      var feedUrl = root.getAttribute('data-feed-url');
      if ((!target && !campaignTiles.length) || !feedUrl) return;
      root.dataset.ccfHydrated = 'true';

      fetch(feedUrl, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (feed) {
          var sources = [];
          if (feed && feed.popular && Array.isArray(feed.popular.products)) {
            sources = sources.concat(feed.popular.products);
          }
          if (feed && feed.hero && Array.isArray(feed.hero.products)) {
            sources = sources.concat(feed.hero.products);
          }
          var seen = {};
          var products = sources.filter(function (product) {
            if (!product || product.available === false || !product.image || (!product.url && !product.handle)) {
              return false;
            }
            var key = productUrl(product).split('?')[0].toLowerCase();
            if (seen[key]) return false;
            seen[key] = true;
            return true;
          });

          if (!products.length) return;

          var rotationIndex = Math.floor(Date.now() / 86400000) % products.length;
          var rotatedProducts = products.slice(rotationIndex).concat(products.slice(0, rotationIndex));

          if (target && products.length >= 3) {
            target.innerHTML = rotatedProducts.slice(0, 3).map(studioProductCard).join('');
          }

          campaignTiles.forEach(function (tile, index) {
            var product = rotatedProducts[index];
            if (!product) return;
            var image = tile.querySelector('img');
            var title = tile.querySelector('span');
            tile.href = productUrl(product);
            tile.setAttribute('aria-label', product.title);
            if (image) {
              image.src = sizedImageUrl(product.image, 720);
              image.srcset =
                sizedImageUrl(product.image, 320) + ' 320w, ' +
                sizedImageUrl(product.image, 540) + ' 540w, ' +
                sizedImageUrl(product.image, 720) + ' 720w';
              image.sizes = '(min-width: 990px) 16vw, 31vw';
              image.alt = product.title;
            }
            if (title) title.textContent = product.title;
          });

          var label = root.querySelector('[data-ccf-campaign-label]');
          var note = root.querySelector('[data-ccf-campaign-note]');
          var kicker = root.querySelector('[data-ccf-campaign-kicker]');
          var title = root.querySelector('[data-ccf-campaign-title]');
          if (label && label.lastChild) label.lastChild.textContent = 'Popular this week';
          if (note) note.textContent = 'Updated weekly';
          if (kicker) kicker.textContent = 'From recent orders';
          if (title) title.textContent = 'Six customer favourites';
          if (campaignLink) campaignLink.setAttribute('aria-label', 'Shop popular cutters');

          root.dataset.ccfProductSource = 'popular-feed';
        })
        .catch(function () {
          root.dataset.ccfProductSource = 'backup-collection';
        });
    });
  }

  function setActiveDockItem() {
    var path = window.location.pathname || '/';
    document.querySelectorAll('[data-ccf-dock-path]').forEach(function (item) {
      var target = item.getAttribute('data-ccf-dock-path') || '';
      var isHome = target === '/' && path === '/';
      var isMatch = target !== '/' && path.indexOf(target) === 0;
      item.classList.toggle('is-active', isHome || isMatch);
      if (isHome || isMatch) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  }

  function connectDockCart() {
    var cartLink = document.querySelector('.ccf-mobile-dock [data-ccf-dock-path="/cart"]');
    var drawer = document.querySelector('cart-drawer');
    if (!cartLink || !drawer || typeof drawer.open !== 'function') return;
    cartLink.addEventListener('click', function (event) {
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      event.preventDefault();
      drawer.open();
    });
  }

  function readHeaderCartCount() {
    var visualCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (!visualCount) return 0;
    var count = parseInt(visualCount.textContent, 10);
    return Number.isFinite(count) ? count : 0;
  }

  function syncDockCartCount() {
    var dockCount = document.querySelector('.ccf-mobile-dock__count');
    if (!dockCount) return;
    var count = readHeaderCartCount();
    dockCount.textContent = String(count);
    dockCount.classList.toggle('is-empty', count < 1);
  }

  function watchCartCount() {
    var headerCart = document.getElementById('cart-icon-bubble');
    if (!headerCart || !('MutationObserver' in window)) return;
    syncDockCartCount();
    new MutationObserver(syncDockCartCount).observe(headerCart, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function connectCategoryDrawer() {
    document.querySelectorAll('details.ccf-category-drawer').forEach(function (drawer) {
      if (drawer.dataset.ccfConnected === 'true') return;
      drawer.dataset.ccfConnected = 'true';

      function syncOpenState() {
        document.body.classList.toggle('ccf-category-open', drawer.open);
      }

      drawer.querySelectorAll('[data-ccf-category-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          drawer.open = false;
          syncOpenState();
          var summary = drawer.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        });
      });

      drawer.querySelectorAll('.ccf-category-drawer__links a').forEach(function (link) {
        link.addEventListener('click', function () {
          drawer.open = false;
          syncOpenState();
        });
      });

      drawer.addEventListener('toggle', syncOpenState);
      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !drawer.open) return;
        event.preventDefault();
        drawer.open = false;
        syncOpenState();
        var summary = drawer.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      });
    });
  }

  function productPriceText(product) {
    var campaignPrice=product.querySelector('.ccf-campaign-price__current');
    if(campaignPrice)return campaignPrice.textContent.trim()+' at checkout';
    var currentPrice = product.querySelector(
      '.price__container .price__sale .price-item--sale, .price__container .price__regular .price-item--regular'
    );
    return currentPrice ? currentPrice.textContent.trim() : '';
  }

  function createMobileBuyBar() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('.product')) return;
    if (document.querySelector('.ccf-mobile-buy')) return;

    var product = document.querySelector('.product');
    var addButton = product && product.querySelector('.product-form__submit');
    var title = product && product.querySelector('.product__title h1');
    if (!product || !addButton || !title) return;

    var bar = document.createElement('div');
    bar.className = 'ccf-mobile-buy';
    bar.setAttribute('data-ccf-mobile-buy', '');
    bar.innerHTML =
      '<div class="ccf-mobile-buy__summary">' +
      '<strong></strong><span></span>' +
      '</div>' +
      '<button class="button ccf-mobile-buy__button" type="button"></button>';

    var summaryTitle = bar.querySelector('strong');
    var summaryPrice = bar.querySelector('.ccf-mobile-buy__summary span');
    var proxyButton = bar.querySelector('button');

    function sync() {
      summaryTitle.textContent = title.textContent.trim();
      summaryPrice.textContent = productPriceText(product);
      proxyButton.textContent = addButton.textContent.trim();
      proxyButton.disabled = addButton.disabled;
    }

    proxyButton.addEventListener('click', function () {
      if (addButton.disabled) {
        addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        addButton.focus({ preventScroll: true });
        return;
      }
      addButton.click();
    });

    document.body.appendChild(bar);
    sync();

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(product, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    }

    var purchaseBarFrame = 0;
    function syncPurchaseBar() {
      purchaseBarFrame = 0;
      var buttonRect = addButton.getBoundingClientRect();
      bar.classList.toggle('is-visible', buttonRect.bottom < 0);
    }

    function queuePurchaseBarSync() {
      if (purchaseBarFrame) return;
      purchaseBarFrame = window.requestAnimationFrame(syncPurchaseBar);
    }

    window.addEventListener('scroll', queuePurchaseBarSync, { passive: true });
    window.addEventListener('resize', queuePurchaseBarSync);
    syncPurchaseBar();
  }

  function strengthenWelcomeOffer() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      host.style.setProperty('--forms-accent-color', '#246f8e', 'important');
      host.style.setProperty('--forms-discount-code-color', '#174d66', 'important');
      host.style.setProperty('--body-text-color', '#526875', 'important');
      host.style.setProperty('--heading-text-color', '#292a27', 'important');
      host.style.setProperty('--form-background-color', '#f6f1e8', 'important');
      host.style.setProperty('--button-text-color', '#ffffff', 'important');
      host.style.setProperty('--button-background-color', '#246f8e', 'important');
      host.style.setProperty('--button-close-background-color', '#fffdf9', 'important');
      host.style.setProperty('--button-close-color', '#292a27', 'important');
      host.style.setProperty('--container-background-color', '#f6f1e8', 'important');
      host.style.setProperty('--form-field-border-radius', '9px', 'important');
      host.style.setProperty('--button-border-radius', '9px', 'important');
      host.style.setProperty('--container-border-radius', '16px', 'important');
      host.style.setProperty('--container-shadow', '0 18px 48px rgba(41,42,39,.16)', 'important');
    });
  }

  function initStudio() {
    hydrateStudioHero();
    setActiveDockItem();
    connectDockCart();
    watchCartCount();
    connectCategoryDrawer();
    createMobileBuyBar();
    strengthenWelcomeOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudio, { once: true });
  } else {
    initStudio();
  }

  document.addEventListener('shopify:section:load', function () {
    hydrateStudioHero();
    connectCategoryDrawer();
    strengthenWelcomeOffer();
  });
})();
